import { useEffect, useState } from "react";

import { API_BASE_URL } from "../../../config";
import ProfileDetailPage from "./ProfileDetailPage";
import Loader from "../../../components/Loader";
import { useParams } from "react-router-dom";

import "../MyProfile.css";

export default function ProffesionalProfile() {
  const [isLoading, setIsLoading] = useState(true);
  const [profileInfo, setProfileInfo] = useState();

  const { id } = useParams();

  useEffect(() => {
    const handleProfile = async () => {
      setIsLoading(true);

      const response = await fetch(
        `${API_BASE_URL}/professional/${id}/profile`
      );

      if (!response.ok) {
        throw new Response("Failed to fetch profile", {
          status: response.status,
        });
      }

      const result = await response.json();

      console.log(result);
      setProfileInfo(result.data);
      setIsLoading(false);
    };

    handleProfile();
  }, []);

  return (
    <>
      {isLoading ? (
        <div className="loading-div-wrapper">
          <Loader />
        </div>
      ) : (
        <ProfileDetailPage details={profileInfo} />
      )}
    </>
  );
}
